import { Layout } from '@/components/Layout';
import { LookupTable } from '../components/LookupTable';
import { lookupsApi } from '../api';

export default function ColorsPage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <LookupTable
          title="Colores"
          description="Gestiona los colores de animales"
          queryKey="colors"
          listFn={lookupsApi.listColors}
          createFn={lookupsApi.createColor}
          updateFn={lookupsApi.updateColor}
          deleteFn={lookupsApi.deleteColor}
        />
      </div>
    </Layout>
  );
}
